import {
  GetLegalEntitiesWithTemplateSettingsDocument,
  UpsertLegalEntityDocumentTemplateSettingDocument,
  UpsertLegalEntityDocumentTemplateSettingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpsertLegalEntityDocumentTemplateSetting = () => {
  const [upsertSetting, { loading }] = useMutation(
    UpsertLegalEntityDocumentTemplateSettingDocument,
    {
      extractorFn: (data) =>
        data.itManagementMutations.upsertItmanagementLegalEntityDocumentTemplateSetting,
      refetchQueries: [GetLegalEntitiesWithTemplateSettingsDocument],
      awaitRefetchQueries: true,
    }
  )

  return {
    loading,
    upsertSetting(variables: UpsertLegalEntityDocumentTemplateSettingMutationVariables) {
      return upsertSetting({
        variables,
      })
    },
  }
}
